import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'

const service = new ApolloClientService()

export default class DefaultCarePlan {
  // The surgery types this clinic is linked to (for the editor's dropdown).
  // Every call takes { customerid } (clinic) or { companyid } (the company
  // template a new clinic is created from); the company form is the same form.
  getSurgeryTypes = (params) => {
    return new Promise((resolve) => {
      ;(params.customerid
        ? service.getDefaultCarePlanSurgeryTypes(params)
        : service.getCompanyCarePlanSurgeryTypes(params)
      )
        .then((data) => resolve(Array.isArray(data) ? data : []))
        .catch((err) => {
          console.log(err)
          resolve([])
        })
    })
  }

  getDefaultCarePlan = (params) => {
    return new Promise((resolve, reject) => {
      ;(params.customerid ? service.getDefaultCarePlan(params) : service.getCompanyCarePlan(params))
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            // Read-side returns the catalogs even on a "not linked" status, so
            // resolve with the payload and let the UI surface data.message.
            resolve({ ...(data || {}), error: true })
          }
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }

  // Clinic only: replace the clinic's care plan, TracPatch settings, goals and
  // reminders with the company's current ones. Resolves with the server's
  // message (which surgery types were copied).
  resetToCompanyCarePlan = (params) => {
    return new Promise((resolve, reject) => {
      service
        .resetClinicToCompanyCarePlan(params)
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            reject({ ...(data || {}), error: true })
          }
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }

  // Clinic only: one surgery type's devices, exercises and questionnaires back
  // to the company plan (the care-plan panel's own Reset button).
  resetClinicCarePlan = (params) => {
    return new Promise((resolve, reject) => {
      service
        .resetClinicCarePlan(params)
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            reject({ ...(data || {}), error: true })
          }
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }

  updateDefaultCarePlan = (params) => {
    return new Promise((resolve, reject) => {
      ;(params.customerid
        ? service.updateDefaultCarePlan(params)
        : service.updateCompanyCarePlan(params)
      )
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            reject({ ...(data || {}), error: true })
          }
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }
}
